var map = {
	"./A/Oval": 0,
	"./A/Oval.svg": 0,
	"./Line": 1,
	"./Line.svg": 1,
	"./___novum-logo-animated": 2,
	"./___novum-logo-animated-long": 3,
	"./___novum-logo-animated-long.svg": 3,
	"./___novum-logo-animated-short": 4,
	"./___novum-logo-animated-short.svg": 4,
	"./___novum-logo-animated.svg": 2,
	"./backgrounds/how_to": 5,
	"./backgrounds/how_to.svg": 5,
	"./backgrounds/how_to/lady": 6,
	"./backgrounds/how_to/lady.svg": 6,
	"./backgrounds/how_to/lady2": 7,
	"./backgrounds/how_to/lady2.svg": 7,
	"./backgrounds/how_to/lady3": 8,
	"./backgrounds/how_to/lady3.svg": 8,
	"./backgrounds/how_to/top": 9,
	"./backgrounds/how_to/top.svg": 9,
	"./backgrounds/how_to2": 10,
	"./backgrounds/how_to2.svg": 10,
	"./backgrounds/videokonf-zoom": 11,
	"./backgrounds/videokonf-zoom.jpg": 11,
	"./cliparts/24-7 support 7": 12,
	"./cliparts/24-7 support 7.svg": 12,
	"./cliparts/3 people": 13,
	"./cliparts/3 people.svg": 13,
	"./cliparts/Comming soon 4": 14,
	"./cliparts/Comming soon 4.svg": 14,
	"./cliparts/Desk Computer 7": 15,
	"./cliparts/Desk Computer 7.svg": 15,
	"./cliparts/Goals 3": 16,
	"./cliparts/Goals 3.svg": 16,
	"./cliparts/Home improvement 1": 17,
	"./cliparts/Home improvement 1.svg": 17,
	"./cliparts/Income up - PMT_M35_08": 18,
	"./cliparts/Income up - PMT_M35_08.svg": 18,
	"./cliparts/Rocket Up": 19,
	"./cliparts/Rocket Up.svg": 19,
	"./cliparts/Start": 20,
	"./cliparts/Start.svg": 20,
	"./cliparts/Work office 10": 21,
	"./cliparts/Work office 10.svg": 21,
	"./cliparts/deal 7": 22,
	"./cliparts/deal 7.svg": 22,
	"./header-rectangle": 23,
	"./header-rectangle.svg": 23,
	"./help/image-face": 24,
	"./help/image-face.jpg": 24,
	"./help/image-person": 25,
	"./help/image-person.jpg": 25,
	"./hms/hms-answer": 26,
	"./hms/hms-answer.jpg": 26,
	"./logo_novum_slogan_white": 27,
	"./logo_novum_slogan_white.png": 27,
	"./logo_novum_social_media": 28,
	"./logo_novum_social_media.jpg": 28,
	"./novum-logo-animated-long": 29,
	"./novum-logo-animated-long.svg": 29,
	"./novum-logo-animated-short": 30,
	"./novum-logo-animated-short.svg": 30,
	"./novum-logo-dark": 31,
	"./novum-logo-dark.png": 31,
	"./novum-logo-white": 32,
	"./novum-logo-white.png": 32
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39;